import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  mainContainer: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      marginTop: 20
    }
  },
  titleSection: {
    fontSize: 30,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.1",
    letterSpacing: -0.66,
    textAlign: "center",
    color: "#00338d"
  },
  containerDescription: {
    display: "flex",
    justifyContent: "center",
    marginTop: 10
  },
  descriptionSection: {
    fontFamily: "Trebuchet",
    fontSize: 15,
    fontWeight: 300,
    letterSpacing: -0.31,
    width: 263,
    textAlign: "center",
    color: "#333333"
  },
  iconSection: {
    width: 35
  },
  subSectionContainer: {
    padding: "30px 0px",
    [theme.breakpoints.up("sm")]: {
      display: "flex"
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 300,
      paddingBottom: 0
    }
  },
  subtitleSection: {
    fontSize: 18,
    color: "rgba(0, 0, 0, 0.87)",
    letterSpacing: -0.38,
    fontWeight: "bold",
    marginLeft: 10
  },
  displayFlex: {
    display: "flex"
  },
  justifyEnd: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      display: "initial"
    }
  },
  alignItemCenter: {
    alignItems: "center"
  },
  subtitleMargin: {
    marginBottom: 20,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 27
    }
  },
  linkContainer: {
    textDecoration: "none !important"
  },
  cardContainer: {
    width: "350px",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
      margin: "10px 17px"
    },
    padding: "9px 5px 5px 29px",
    borderRadius: "8px",
    backgroundColor: "#fafafa",
    margin: "8px 0px"
  },
  titleCard: {
    fontSize: "17px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#0073cf",
    marginBottom: 5
  },
  descriptionCard: {
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.25",
    letterSpacing: "-0.25px",
    color: "#727272",
    width: 330,
    [theme.breakpoints.down("xs")]: {
      width: "auto"
    }
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: 5
  },
  arrowIcon: {
    fontSize: "14px",
    fontWeight: 700
  },
  colorGris: {
    color: "#0073cf"
  },
  iconSize: {
    fontSize: 14,
    fontWeight: "bold"
  },
  grandientContainer: {
    position: "relative",
    width: "100%",
    padding: "8px 0px 0px 30px",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      padding: "15px 0px 90px 0px"
    },
    backgroundImage:
      "linear-gradient(to left, #9dd8f2, #bee0f9, #dae8fc, #f0f3fe, #ffffff)"
  },
  leftContact: {
    marginRight: "100px",
    [theme.breakpoints.down("lg")]: {
      marginRight: "50px"
    },
    [theme.breakpoints.down("md")]: {
      marginRight: "0px"
    }
  },
  descriptionPhone: {
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "-0.38px",
    color: "rgba(0, 0, 0, 0.87)",
    width: "normal"
  },
  leftContainer: {
    padding: "8px 30px 0px 0px",
    [theme.breakpoints.down("xs")]: {
      padding: 0
    }
  },
  containerContactImage: {
    // position: "absolute",
    // top: -21,
    display: "flex",
    // [theme.breakpoints.up("lg")]: {
    //   right: 90
    // },
    // [theme.breakpoints.up("md")]: {
    //   right: 15,
    //   width: 240
    // },
    [theme.breakpoints.down("xs")]: {
      bottom: "-300px",
      position: "absolute",
      left: "0",
      right: "0",
      marginLeft: "auto",
      marginRight: "auto",
      width: "190px"
    }
  },
  contactImage: {
    height: 370
  }
}));

export default styles;
